import React from 'react';
import ReactDOM from 'react-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import './index.css';
import "video-react/dist/video-react.css";
import AppRouter from './router';
import { unregister } from './registerServiceWorker';

const theme = createMuiTheme({
    typography: {
        // Use the system font.
        fontFamily:
            'Kanit,' +
            '"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
    },
})

function App() {
    return (
        <MuiThemeProvider theme={theme}>
            <AppRouter />
        </MuiThemeProvider>
    );
}

ReactDOM.render(<App />, document.getElementById('root'));
// เลิกใช้ service worker (cache-first) ที่ทำให้ผู้ใช้ค้างเวอร์ชันเก่าจนกว่าจะ clear cache
// unregister จะถอน SW ที่ผู้ใช้เคยติดตั้งไว้ออกด้วย
unregister();
